





import Vue from "vue";
import { Component } from "vue-property-decorator";
import "@/assets/themes/cpa/styles.scss";
import { EventBus } from "@/EventBus.ts";

@Component({
  name: "college-prep-alabama",
})
export default class CollegePrepAlabama extends Vue {
  public mounted() {
    EventBus.$emit("theme:loaded");
  }
}
